export type StickerAttributionQuery = {
  socialShopId?: string | null;
  glowId?: string | null;
};

/** Query keys forwarded when navigating between stickers in a shop or embed context */
export const STICKER_NAV_QUERY_KEYS = [
  'socialShopId',
  'glowId',
  'embedOrganizationId',
  'embedSource',
  'standalone',
] as const;

export function pickStickerAttributionQuery(
  query: Record<string, unknown>,
): StickerAttributionQuery {
  return {
    socialShopId: (query.socialShopId as string) || null,
    glowId: (query.glowId as string) || null,
  };
}

export function appendStickerAttributionQuery(
  baseUrl: string,
  attribution: StickerAttributionQuery,
): string {
  const params = new URLSearchParams();

  if (attribution.socialShopId) {
    params.set('socialShopId', String(attribution.socialShopId));
  }
  if (attribution.glowId) {
    params.set('glowId', String(attribution.glowId));
  }

  const query = params.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

export function buildStickerShareUrl(
  slugOrId: string,
  attribution?: StickerAttributionQuery,
): string {
  const base = `${import.meta.env.VITE_WEB_BASE_URL}/web/sticker/${slugOrId}`;
  return appendStickerAttributionQuery(base, attribution ?? {});
}

export function buildStickerPathWithAttribution(
  slugOrId: string,
  attribution?: StickerAttributionQuery,
): string {
  const base = `/web/sticker/${slugOrId}`;
  return appendStickerAttributionQuery(base, attribution ?? {});
}

export function copyStickerNavQueryParams(
  query: Record<string, unknown>,
): URLSearchParams {
  const params = new URLSearchParams();

  STICKER_NAV_QUERY_KEYS.forEach((key) => {
    const value = query[key];
    if (value != null && value !== '') {
      params.set(key, String(value));
    }
  });

  return params;
}
